// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* variables.css */
:root {

  --theam-color: #157a3d;
  --card-color: lightgreen;
  --content-container-bg-light: white;
  --content-container-bg-dark: #111;
  /* Define a dark background color */

  --save-btn-bg-dark: #111;
  /* Define a dark background color */
  --save-btn-bg-light: #157a3d;
  /* Define a dark background color */

  --cancel-btn-bg-dark: #000000;
  --cancel-btn-bg-light: #f9f9f9;

  --cancel-btn-color-dark: #f9f9f9;
  --cancel-btn-color-light: #157a3d;

  --custom-scrollbar-thumb-background: #c5c5c5;


}

/* WebKit (Chrome, Safari, etc.) */
/* Vertical scrollbar */
::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}

::-webkit-scrollbar-thumb {
  background-color: var(--custom-scrollbar-thumb-background);
}

/* Horizontal scrollbar */
::-webkit-scrollbar-horizontal {
  height: 4px;
}

::-webkit-scrollbar-thumb:horizontal {
  background-color: var(--custom-scrollbar-thumb-background);
}

/* Firefox */
/* Note: You may need to use a browser-specific prefix for Firefox */
/* For example: scrollbar-thumb */
/* For the purpose of this example, we'll use the unprefixed version */
/* You may need to add appropriate prefixes for cross-browser compatibility */

/* For both Firefox vertical and horizontal scrollbars */
* {
  scrollbar-color: var(--custom-scrollbar-thumb-background) transparent;
}

/* Edge */
/* For Edge vertical scrollbar */
*::-ms-scrollbar-thumb {
  background-color: var(--custom-scrollbar-thumb-background);
}

/* For Edge horizontal scrollbar */
*::-ms-scrollbar-thumb:horizontal {
  background-color: var(--custom-scrollbar-thumb-background);
}`, "",{"version":3,"sources":["webpack://./src/styles/variables.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;;EAEE,sBAAsB;EACtB,wBAAwB;EACxB,mCAAmC;EACnC,iCAAiC;EACjC,mCAAmC;;EAEnC,wBAAwB;EACxB,mCAAmC;EACnC,4BAA4B;EAC5B,mCAAmC;;EAEnC,6BAA6B;EAC7B,8BAA8B;;EAE9B,gCAAgC;EAChC,iCAAiC;;EAEjC,4CAA4C;;;AAG9C;;AAEA,kCAAkC;AAClC,uBAAuB;AACvB;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,0DAA0D;AAC5D;;AAEA,yBAAyB;AACzB;EACE,WAAW;AACb;;AAEA;EACE,0DAA0D;AAC5D;;AAEA,YAAY;AACZ,oEAAoE;AACpE,iCAAiC;AACjC,sEAAsE;AACtE,6EAA6E;;AAE7E,wDAAwD;AACxD;EACE,qEAAqE;AACvE;;AAEA,SAAS;AACT,gCAAgC;AAChC;EACE,0DAA0D;AAC5D;;AAEA,kCAAkC;AAClC;EACE,0DAA0D;AAC5D","sourcesContent":["/* variables.css */\r\n:root {\r\n\r\n  --theam-color: #157a3d;\r\n  --card-color: lightgreen;\r\n  --content-container-bg-light: white;\r\n  --content-container-bg-dark: #111;\r\n  /* Define a dark background color */\r\n\r\n  --save-btn-bg-dark: #111;\r\n  /* Define a dark background color */\r\n  --save-btn-bg-light: #157a3d;\r\n  /* Define a dark background color */\r\n\r\n  --cancel-btn-bg-dark: #000000;\r\n  --cancel-btn-bg-light: #f9f9f9;\r\n\r\n  --cancel-btn-color-dark: #f9f9f9;\r\n  --cancel-btn-color-light: #157a3d;\r\n\r\n  --custom-scrollbar-thumb-background: #c5c5c5;\r\n\r\n\r\n}\r\n\r\n/* WebKit (Chrome, Safari, etc.) */\r\n/* Vertical scrollbar */\r\n::-webkit-scrollbar {\r\n  width: 4px;\r\n  height: 4px;\r\n}\r\n\r\n::-webkit-scrollbar-thumb {\r\n  background-color: var(--custom-scrollbar-thumb-background);\r\n}\r\n\r\n/* Horizontal scrollbar */\r\n::-webkit-scrollbar-horizontal {\r\n  height: 4px;\r\n}\r\n\r\n::-webkit-scrollbar-thumb:horizontal {\r\n  background-color: var(--custom-scrollbar-thumb-background);\r\n}\r\n\r\n/* Firefox */\r\n/* Note: You may need to use a browser-specific prefix for Firefox */\r\n/* For example: scrollbar-thumb */\r\n/* For the purpose of this example, we'll use the unprefixed version */\r\n/* You may need to add appropriate prefixes for cross-browser compatibility */\r\n\r\n/* For both Firefox vertical and horizontal scrollbars */\r\n* {\r\n  scrollbar-color: var(--custom-scrollbar-thumb-background) transparent;\r\n}\r\n\r\n/* Edge */\r\n/* For Edge vertical scrollbar */\r\n*::-ms-scrollbar-thumb {\r\n  background-color: var(--custom-scrollbar-thumb-background);\r\n}\r\n\r\n/* For Edge horizontal scrollbar */\r\n*::-ms-scrollbar-thumb:horizontal {\r\n  background-color: var(--custom-scrollbar-thumb-background);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
